export default __webpack_public_path__ + "static/media/play-icon.c26d8069.svg";